document.addEventListener('DOMContentLoaded', function () {
  /* Some pages load this file twice (e.g. sport pages via both cl-hero and their own
     section). Mark each widget once it's wired so a second copy doesn't bind a second
     click handler, which would open and immediately re-close every FAQ. */
  document.querySelectorAll('.cl-faq').forEach(function (faq) {
    if (faq.hasAttribute('data-cl-faq-ready')) return;
    faq.setAttribute('data-cl-faq-ready', '');
    faq.querySelectorAll('.cl-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cl-faq__item');
        var open = item.classList.contains('is-open');
        faq.querySelectorAll('.cl-faq__item').forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.cl-faq__q').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  document.querySelectorAll('[data-cl-leaders]').forEach(function (root) {
    if (root.hasAttribute('data-cl-leaders-ready')) return;
    root.setAttribute('data-cl-leaders-ready', '');
    var track = root.querySelector('.cl-leaders__track');
    var slides = root.querySelectorAll('.cl-leaders__slide');
    var dots = root.querySelectorAll('.cl-leaders__dot');
    var n = slides.length;
    var i = 0;
    function render() {
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    root.querySelectorAll('[data-cl-prev]').forEach(function (b) { b.addEventListener('click', function () { i = (i - 1 + n) % n; render(); }); });
    root.querySelectorAll('[data-cl-next]').forEach(function (b) { b.addEventListener('click', function () { i = (i + 1) % n; render(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { i = k; render(); }); });
  });
});
